import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function SowManagementIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props}>
      <mask
        id="mask0_10558_27435"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10558_27435)">
        <path
          d="M9 9V7H18V9H9ZM9 12V10H18V12H9ZM12 22H6C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V16H6V2H21V11.025C20.6667 10.9917 20.3292 11.0042 19.9875 11.0625C19.6458 11.1208 19.3167 11.225 19 11.375V4H8V16H14L12 18H5V19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20H12V22ZM14 22V18.925L19.525 13.425C19.675 13.275 19.8417 13.1667 20.025 13.1C20.2083 13.0333 20.3917 13 20.575 13C20.775 13 20.9667 13.0375 21.15 13.1125C21.3333 13.1875 21.5 13.3 21.65 13.45L22.575 14.375C22.7083 14.525 22.8125 14.6917 22.8875 14.875C22.9625 15.0583 23 15.2417 23 15.425C23 15.6083 22.9667 15.7958 22.9 15.9875C22.8333 16.1792 22.725 16.35 22.575 16.5L17.075 22H14ZM15.5 20.5H16.45L19.475 17.45L19.025 16.975L18.55 16.525L15.5 19.55V20.5ZM19.025 16.975L18.55 16.525L19.475 17.45L19.025 16.975Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}
